import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/sl7QB5g6YAkBuTK6o7u7/locations/0pbwlEwY9WKPzpaFShj7`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="85%"
                  maxWidth="280px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/sl7QB5g6YAkBuTK6o7u7/locations/0pbwlEwY9WKPzpaFShj7`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="100%"
                  maxWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
